<template>
  <div>
    <AdContract v-model="show" />

    <slot />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AdContract from './AdContract';
import { AD_CONTRACT, HAS_SEEN_CONTRACT } from '@/store/types';

export default {
  name: 'RequireAdContract',
  components: {
    AdContract,
  },
  data() {
    return {
      show: false,
    };
  },

  computed: {
    ...mapGetters({
      accepted: AD_CONTRACT,
      hasSeenContract: HAS_SEEN_CONTRACT,
    }),
  },
  created() {
    this.getContractStatus().then(() => {
      if (!this.accepted && !this.hasSeenContract) {
        this.show = true;
        this.setHasSeenContract(true);
      }
    });
  },
  methods: {
    ...mapActions({
      getContractStatus: AD_CONTRACT,
      setHasSeenContract: HAS_SEEN_CONTRACT,
    }),
  },
};
</script>
